import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSiteTrackerTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerTable`
});

export const GetSiteTrackerUpdateTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerUpdateTable`
});

export const GetSiteTrackerLcsCreateTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerCreateLcsTable`
});

export const CreateSiteEntryRequest = (siteTrackerCreateDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/CreateSiteTracker`,
	data: siteTrackerCreateDto
});

export const EditSiteEntryRequest = (SiteTracker) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/EditSiteTracker`,
	data: SiteTracker
});

export const GetSiteTrackerDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerDropdowns`
});

export const GetSiteTrackerBSHDropdownRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerBSHDropdown`
});

export const GetSiteTrackerBSHDropdownWlcsRequest = (lcs) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerBSHDropdownWlcs`,
	params: { lcs }
});

export const GetSiteTypeDropdownRequest = (lcs) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerSiteTypeDropdown`,
	params: { lcs }
});

export const GetSiteTrackerSiteNameDropdownRequest = (lcs, siteType) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerSiteNameDropdown`,
	params: { lcs, siteType }
});

export const GetSiteTrackerDasZoneDropdownRequest = (siteLCS, siteBSH, siteType) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerDasZoneDropdown`,
	params: { siteLCS, siteBSH, siteType }
});

export const GetSiteTrackerRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTracker`,
	params: { id }
});

export const GetSiteTrackerToEditRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerToEdit`,
	params: { id }
});

export const GetCommentsHistoryRequest = (id, commentType) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetCommentsHistory`,
	params: { id, commentType }
});

export const GetExportTrackerRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteTrackerExport`
});

export const ImportSiteTrackerRequest = (siteTrackerFilePath, user) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ImportSiteTracker`,
	params: { siteTrackerFilePath, user }
});

export const ExportSiteTrackerTemplateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ExportSiteTrackerTemplate`
});

export const RemoveSiteEntryRequest = (id, user) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/RemoveSiteTrackerEntry`,
	params: { id, user }
});

export const GetReportEmailRequest = (id, user) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/GetSiteDReportEmail`,
	params: { id, user }
});

export const UpdateSiteActivationDatesRequest = (siteIdsToUpdate) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/UpdateSiteActivationDates`,
	data: siteIdsToUpdate
});

export const CreateNewSiteTrackerEntriesRequest = (lcsToCreate) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteTracker/CreateNewSiteTrackerEntries`,
	data: lcsToCreate
});
